import * as actionTypes from './actionTypes';
import axios from '../../axios-api';


export const getAdminWithFires = (geoserverUrl, table, nameField, codeField) => {
    return dispatch => {
        dispatch(getAdminWithFiresStarted());
        axios.get(`${geoserverUrl}burned_areas/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=burned_areas:stats_admin_with_fires&outputFormat=application/json&viewparams=TABLE:${table};NAME:${nameField};CODE:${codeField}`)
            .then(response => {
                dispatch(getAdminWithFiresSuccess(response.data));
            })
            .catch( error => {
            });
    };
};

export const getAdminWithFiresSuccess = (admin) => {
    return {
        type: actionTypes.GET_ADMIN_WITH_FIRES_SUCCESS,
        admin: admin
    };
};

export const getAdminWithFiresStarted = () => {
    return {
        type: actionTypes.GET_ADMIN_WITH_FIRES_STARTED
    };
};

export const getStatistics = (geoserverUrl, table, value, selectedStatsType, codeField) => {
    let url = `${geoserverUrl}burned_areas/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=burned_areas:stats_fires_admin&outputFormat=application/json&viewparams=TABLE:${table};VALUE:${value};FIELD:${codeField}`;

    if (table === "country" && selectedStatsType === "fires"){
        url = `${geoserverUrl}burned_areas/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=burned_areas:stats_fires_country&outputFormat=application/json`;
        
    } else if (table === "country" && selectedStatsType === "clc"){
        url = `${geoserverUrl}burned_areas/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=burned_areas:stats_fires_clc_country&outputFormat=application/json`;
    
    } else if (selectedStatsType === "clc"){
        url = `${geoserverUrl}burned_areas/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=burned_areas:stats_fires_clc&outputFormat=application/json&viewparams=TABLE:${table};VALUE:${value};FIELD:${codeField}`;
    }

    return dispatch => {
        axios.get(url)
            .then(response => {
                dispatch(getStatisticsSuccess(response.data, selectedStatsType));        
            })
            .catch( error => {
            });
    };
};

export const getStatisticsSuccess = (stats, selectedStatsType) => {
    return {
        type: actionTypes.GET_STATISTICS_SUCCESS,
        stats: stats,
        selectedStatsType: selectedStatsType
    };
};

export const updateSimpleVariable = (variableName, newValue) => {
    return {
        type: actionTypes.UPDATE_SIMPLE_VARIABLE,
        variableName: variableName,
        newValue: newValue
    };
};

export const changeClcYear = (year) => {
    return {
        type: actionTypes.CHANGE_CLC_YEAR,
        year: year
    };
};